import { ExistingFirmResponse } from 'api/firm/firm.types';

export const PRECEPT_FINANCE_FIRM_ID = 'q7v2qrbj7wt0io6jkb9lmpjz';

export function isPreceptFinanceFirm(firm: ExistingFirmResponse | null | undefined): boolean {
  return firm?.id === PRECEPT_FINANCE_FIRM_ID;
}
